import React, { useState, useEffect } from 'react';
import { getChats, getAllUsers, deleteChat, getUserData } from '../services/api';

function Sidebar({ 
  user, 
  chats = [], 
  currentChat, 
  onOpenChat, 
  onLogin, 
  onlineUsers = [], 
  isUserOnline, 
  usersData = {},
  isMobile = false
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    if (user) {
      getAllUsers().then(res => {
        const users = res.data.filter(u => u !== user.username);
        setAllUsers(users);
      }).catch(err => {
        console.error('Ошибка загрузки пользователей:', err);
      });
    }
  }, [user]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query.trim() || !user) {
      setSearchResults([]);
      return;
    }

    const filtered = allUsers.filter(u =>
      u.toLowerCase().includes(query.toLowerCase())
    );
    setSearchResults(filtered);
  };

  const handleDeleteChat = async (username, e) => {
    e.stopPropagation();
    if (!window.confirm(`🗑️ Удалить чат с пользователем "${username}"?\n\nВсе сообщения будут удалены безвозвратно.`)) {
      return;
    }
    
    try {
      await deleteChat(username);
      alert('✅ Чат успешно удален');
      if (currentChat?.username === username) {
        onOpenChat(null);
      }
    } catch (err) {
      console.error('Ошибка удаления чата:', err);
      alert('❌ Ошибка удаления чата: ' + (err.response?.data?.error || err.message));
    }
  };

  let displayItems = [];
  if (searchQuery.trim() && searchResults.length > 0) {
    displayItems = searchResults.map(username => ({
      username,
      lastMessage: 'Начать диалог',
      isSearchResult: true,
      avatar: usersData[username]?.avatar || '👤'
    }));
  } else if (searchQuery.trim() && searchResults.length === 0) {
    displayItems = [];
  } else {
    displayItems = chats.map(chat => ({
      ...chat,
      avatar: usersData[chat.username]?.avatar || '👤'
    }));
  }

  return (
    <div className="sidebar">
      {!isMobile && (
        <div className="sidebar-header">
          <h2>💬 HakBar Messenger</h2>
          <div className="online-status" style={{ color: user ? '#00b894' : '#666' }}>
            {user ? 'Онлайн' : 'Офлайн'}
          </div>
        </div>
      )}

      {user && (
        <div className="search-box">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Поиск по юзернейму..."
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      )}

      {!user ? (
        <div className="empty-state">
          <div className="icon">🔒</div>
          <h3>Войдите в аккаунт</h3>
          <p style={{ fontSize: '13px', color: '#555' }}>Авторизуйтесь чтобы начать общение</p>
        </div>
      ) : (
        <div className="chat-list">
          {displayItems.length === 0 ? (
            <div className="empty-state">
              <div className="icon">{searchQuery.trim() ? '🔍' : '💬'}</div>
              <h3>{searchQuery.trim() ? 'Пользователи не найдены' : 'Нет чатов'}</h3>
              <p style={{ fontSize: '13px', color: '#555' }}>
                {searchQuery.trim() ? 'Попробуйте изменить запрос' : 'Найдите пользователей через поиск'}
              </p>
            </div>
          ) : (
            displayItems.map(chat => {
              const online = isUserOnline ? isUserOnline(chat.username) : false;
              const avatar = chat.avatar || '👤';
              
              return (
                <div
                  key={chat.username}
                  className={`chat-item ${currentChat?.username === chat.username ? 'active' : ''}`}
                  onClick={() => {
                    setSearchQuery('');
                    setSearchResults([]);
                    onOpenChat(chat.username);
                  }}
                  style={{ position: 'relative' }}
                >
                  <div className="avatar">
                    {avatar && avatar.startsWith('data:image') ? (
                      <img 
                        src={avatar} 
                        alt={chat.username}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    ) : (avatar || '👤')}
                  </div>
                  <div className="chat-info">
                    <div className="name">
                      {chat.username}
                      <span 
                        className="status-dot"
                        style={{
                          display: 'inline-block',
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          marginLeft: '8px',
                          background: online ? '#00b894' : '#666',
                          transition: 'background 0.3s'
                        }}
                      />
                      <span style={{ 
                        fontSize: '11px', 
                        color: online ? '#00b894' : '#666',
                        marginLeft: '4px'
                      }}>
                        {online ? 'онлайн' : 'оффлайн'}
                      </span>
                    </div>
                    <div className="last-msg">{chat.lastMessage || 'Начать диалог'}</div>
                  </div>
                  
                  <button 
                    className="chat-menu-btn"
                    onClick={(e) => handleDeleteChat(chat.username, e)}
                    title="Удалить чат"
                  >
                    ⋮
                  </button>
                  
                  {chat.unread > 0 && <div className="unread">{chat.unread}</div>}
                  {chat.isSearchResult && (
                    <div style={{ fontSize: '11px', color: '#6c5ce7' }}>👤</div>
                  )}
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
}

export default Sidebar;